jQuery($ => {
    class GoogleMap {
        constructor(element) {
            this._ = element;
            this._element = $(element);
            this._map        = this._element.find('.m-google-map__map');
            this._pins       = this._element.find('.m-google-map__pin');
            this._center_lat = this._map.data('center-lat');
            this._center_lng = this._map.data('center-lng');
            this._zoom       = this._map.data('zoom');

            this.init();
        } 

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Initialize
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        init() {
            this.setupHandlers();
            this._element.trigger('init', this);
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Setup Handlers
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        setupHandlers() {
            $(window).on('load', this.handleLoadGoogleMap);
            $(window).on('resize', this.refreshBounds);
        }

        handleLoadGoogleMap = () => {
            this.setupGoogleMap();
            this.setupMarkers();
            this.refreshBounds();
        }

        setupGoogleMap = () => {
            this._map.map = new google.maps.Map(this._map[0], {
                center: {
                    lat: this._center_lat,
                    lng: this._center_lng
                },
                zoom: this._zoom,
                maxZoom: 6,
                disableDefaultUI: true,
                zoomControl: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [{ "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#000000" }, { "lightness": 100 }] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#000000" }, { "lightness": 16 }] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#000000" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#410000" }, { "lightness": 17 }, { "weight": 1.2 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 20 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 21 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#000000" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#000000" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 16 }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 19 }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "lightness": 17 }, { "color": "#1a1a1a" }] }]
            });
        }

        setupMarkers = () => {
            this._pins.each((index, pin) => {
                const $pin = $(pin);
                const $url = $pin.data('url');

                pin.marker = new google.maps.Marker({
                    position: {
                        lat: $pin.data('lat'),
                        lng: $pin.data('lng')
                    },
                    map: this._map.map,
                    icon: {
                        url: GOOGLEMAP.icon,
                        scaledSize: new google.maps.Size(40, 40)
                    }
                });

                pin.marker.addListener("click", ({ domEvent, latLng }) => {
                    const { target } = domEvent;

                    if ($url) {
                        window.location.href = $url;
                    }
                });
            });
        }

        refreshBounds = () => {
            var bounds = new google.maps.LatLngBounds();

            this._pins.each((index, pin) => {
                bounds.extend({
                    lat: pin.marker.position.lat(),
                    lng: pin.marker.position.lng()
                });
            });

            this._map.map.fitBounds(bounds);

        }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $.fn.google_map = function () {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].google_map = new GoogleMap(_[i], opt);
            else
                ret = _[i].google_map[opt].apply(_[i].google_map, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
 
    $('.m-google-map').google_map();
});